export class AssignmentReport {
    StartDate: string;
    EndDate: string;
    AssignedStudentIDs: { ID: number }[];
    ActivitySequence: ActivitySequenceReport;
    CompletedActivities: CompletedActivityReport[];
}

export class ActivitySequenceReport {   
    ActivitySequenceID: number;
    Name: string;
    Activities: ActivityReport[];
}

export class ActivityReport {
    AssignedActivityID: string;
    ActivityID: string;
    Title: string;
    UnitNumber: number;
    CategoryID: number;
    MinTime: number;
    MaxTime: number;
    Level: number;
}

export class CompletedActivityReport {
    AssignedActivityID: string;
    CompletedAt: StudentCompletedActivityReport[];
}

export class StudentCompletedActivityReport {
    StudentID: number;
    CompletedAt: string;
}